import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { resetPassword } from '../services/Login';
import './Login.css';

function RequestRecoverPassword() {
  const [email, setEmail] = useState('');
  const [showAlert, setShowAlert] = useState(false); 
  const [alertText, setAlertText] = useState(''); 
  const [alertVariant, setAlertVariant] = useState('warning');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsButtonDisabled(true);

    if (email === '') {        
        setShowAlert(true);
        setAlertText('El campo de correo electrónico no puede estar vacío.');
        setAlertVariant('warning');
        setIsButtonDisabled(false);
    } else {
        setShowAlert(false);
        setAlertText('');    
        
        const requestBody = {
            email: email
        };    
        
        resetPassword(requestBody).then((resetResult) => {
            if(resetResult.result) {
                setRequestSent(true);
                setShowAlert(true);
                setAlertText('Se ha enviado un correo electrónico con las instrucciones para restablecer tu contraseña. Por favor, revisa tu bandeja de entrada y también la carpeta de spam o correo no deseado.');
                setAlertVariant('success');
                setEmail('');
                setIsButtonDisabled(false);
            } else {
                setShowAlert(true);
                setAlertText('Ocurrió un error al procesar tu solicitud. Por favor, verifica que el correo electrónico sea correcto e intenta nuevamente.');
                setAlertVariant('danger');
                setIsButtonDisabled(false);
            }
        }).catch(() => {
            setShowAlert(true);
            setAlertText('Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente más tarde.');
            setAlertVariant('danger');
            setIsButtonDisabled(false);
        });
    }
  };

  return (
    <div className="bg-dark d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Container>
        <Row className="justify-content-center">
          <Col xl={4} className='text-center'>
            <div className="login-logo">
              <i className="bi bi-boxes"></i>
            </div>
            <h2 className="text-center text-white mb-2">Recuperar contraseña</h2>
            <p className="text-white-50 mb-4">Ingresa tu correo electrónico para recibir instrucciones</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xl={4} className='text-center'>
            {!requestSent && (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className="text-white">Correo electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Ingrese su correo electrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}                   
                  />               
                </Form.Group>
                <Button className='mt-4 me-2' variant="primary" type="submit" disabled={isButtonDisabled}>
                  Enviar solicitud
                </Button>
                <Button className='mt-4' variant="outline-light" type="button" onClick={handleBackToLogin}>
                  Volver al inicio de sesión
                </Button>
              </Form>
            )}
            
            {requestSent && (
              <div className="mt-3">
                <Button variant="outline-light" onClick={handleBackToLogin}>
                  Volver al inicio de sesión
                </Button>
              </div>
            )}
          </Col>
        </Row>
        <Row className="justify-content-center mt-4">
          <Col xl={4} className='text-center'>
            <Alert variant={alertVariant} show={showAlert}>
              {alertText}
            </Alert>
          </Col>
        </Row> 
      </Container>
    </div>
  );
}

export default RequestRecoverPassword;
